export const $Gray90 = '#e5e5e5'
export const $PinkRed = '#bf0b30'
export const $WhiteSmoke = '#F5F5F5'
export const $Gray75 = '#757575'
export const $White = '#ffffff'
export const $DarkShadeBlue = '#2d3f8f'
export const $Snow = '#FBFBFB'
export const $Gray77 = '#C4C4C4'
export const $Manatee = '#898A8D'
export const $Gainsboro = '#DADADA'
export const $LightShadeBlue = '#d8ddf3'
export const $Whisper = '#e5e5e5'
export const $VeryLightBlue = '#f2f2f2'
export const $SelectedOption = 'rgba(25, 118, 210, 0.08)'
export const $HoverOption = 'rgba(0, 0, 0, 0.04)'
export const $primaryColor = '#03a597'
export const $secondaryColor = '#213164'
